import { CustomerSearchDataFragment } from "@bonliva-crm/graphql";
import locale from "@bonliva-crm/locale";
import { Color } from "@bonliva-crm/ui";
import { Box, Card, Chip, Radio, Typography, makeStyles } from "@material-ui/core";
import { transparentize } from "polished";

type Props = {
  customer: CustomerSearchDataFragment;
  selected: boolean;
  setSelected: (id: string | null) => void;
  showRadioButton?: boolean;
};

export const CustomerCard = ({
  customer,
  selected,
  setSelected,
  showRadioButton
}: Props) => {
  const classes = useStyles({ selected });

  return (
    <div style={{ width: "100%", height: "100%", padding: "0px 23px 18px 0px" }}>
      <Card className={classes.root} onClick={() => setSelected(customer._id)}>
        <Box className={classes.header}>
          <Typography variant="h6" component="span">
            {customer.Name}{" "}
          </Typography>
          <Chip
            size="small"
            variant="outlined"
            color="primary"
            label={
              <Typography variant="subtitle1" style={{ color: Color.Body }}>
                {locale.customerType[customer.Type]}
              </Typography>
            }
            style={{
              border: `1px solid ${Color.Brown}`,
              backgroundColor: transparentize(0.75, Color.Brown)
            }}
          />
        </Box>
        <Typography variant="body2" style={{ color: Color.PrimaryMain }}>
          {customer.Parents.map((p) => p.Name).join(" > ")}
        </Typography>
        {customer.Address?.City && (
          <Box>
            <Typography variant="body2" style={{ fontWeight: 500 }} component="span">
              {locale.City}
              {": "}
            </Typography>
            <Typography variant="body2" component="span">
              {customer.Address?.City}
            </Typography>
          </Box>
        )}
        {customer.AreasOfExpertise.length > 0 && (
          <Box>
            <Typography variant="body2" style={{ fontWeight: 500 }} component="span">
              {locale.AreaOfExpertise}
              {": "}
            </Typography>
            <Typography variant="body2" component="span">
              {customer.AreasOfExpertise.join(", ")}
            </Typography>
          </Box>
        )}
        {customer.journalSystem && (
          <Box>
            <Typography variant="body2" style={{ fontWeight: 500 }} component="span">
              {locale.system}
              {": "}
            </Typography>
            <Typography variant="body2" component="span">
              {customer.journalSystem}
            </Typography>
          </Box>
        )}
        {showRadioButton && <Radio className={classes.radio} checked={selected} />}
      </Card>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: (props: { selected: boolean }) => ({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    borderRadius: "0.375rem",
    border: props.selected
      ? `1px solid ${Color.PrimaryMain}`
      : `1px solid ${Color.LightGray}`,
    background: props.selected ? transparentize(0.85, Color.PrimaryMain) : Color.OffWhite,
    boxShadow: `1px 6px 24px 0px ${Color.BoxShadow}`,
    "&:hover": {
      cursor: "pointer"
    }
  }),
  header: {
    display: "flex",
    flexDirection: "row",
    gap: "0.5rem",
    alignItems: "center"
  },
  radio: {
    position: "absolute",
    top: "0",
    right: "0"
  }
}));
